import { FC, ReactNode } from 'react';
import { Stack, Toolbar } from '@mui/material';

type TableToolbarShellProps = {
  children: ReactNode;
  /** Skip horizontal padding when a parent Paper already pads the content. */
  flush?: boolean;
};

/** Shared dense table toolbar: aligned controls, no MUI 56px min-height, consistent padding. */
export const TableToolbarShell: FC<TableToolbarShellProps> = ({
  children,
  flush = false,
}) => (
  <Toolbar
    disableGutters
    component={Stack}
    direction={{ xs: 'column', sm: 'row' }}
    alignItems={{ xs: 'stretch', sm: 'center' }}
    justifyContent="space-between"
    sx={{
      px: flush ? 0 : 1.5,
      py: flush ? 0.75 : 1.25,
      mb: flush ? 1 : 0,
      gap: 1.5,
      width: '100%',
      minHeight: 'unset !important',
    }}
  >
    {children}
  </Toolbar>
);
